import React, { FC, useEffect } from 'react';
import { BigidMeRequestInfoWrapper } from '../../components/BigidMeRequestInfoWrapper';
import { TenantContainer } from '../../state/tenantContainer';
import { useParams } from 'react-router-dom';

// translation not needed BME-10200
export const ManualRequestSessionError: FC = () => {
  const { publishName } = useParams<'publishName'>();
  const { loadTenantSettings } = TenantContainer.useContainer();

  useEffect(() => {
    loadTenantSettings({ publishName });
  }, [loadTenantSettings, publishName]);

  return (
    <BigidMeRequestInfoWrapper
      componentNaming="ConsumerDataAlreadyUpdated"
      pageTitle="Your session has expired"
      title="Your session has expired"
    >
      Please reopen the link to continue (valid for 1 hour)
    </BigidMeRequestInfoWrapper>
  );
};
